import request from '@/utils/request'

export function getClientTypeList() {
  return request.post('/client-type/list')
}

export function addClientType(data) {
  return request.post('/client-type/add', data)
}

export function modifyClientType(data) {
  return request.post('/client-type/modify', data)
}

export function deleteClientType(data) {
  return request.post('/client-type/delete', data)
}

export function getClientList(data) {
  return request.post('/client/list', data)
}

export function addClient(data) {
  return request.post('/client/add', data)
}

export function modifyClient(data) {
  return request.post('/client/modify', data)
}

export function deleteClient(data) {
  return request.post('/client/delete', data)
}

export function setStatusOfClient(data) {
  return request.post('/client/up-down-shelf', data)
}

export function sendSmsOfClientTerm(data) {
  return request.post('/client-term/send-sms', data)
}

export function registerOfClientTerm(data) {
  return request.post('/client-term/register', data)
}

export function loginOfClientTerm(data) {
  return request.post('/client-term/login', data)
}

export function getLoginInfoOfClientTerm(data) {
  return request.post('/client-term/get-login-info', data)
}

export function logoutOfClientTerm(data) {
  return request.post('/client-term/logout', data)
}

export function rePasswordOfClientTerm(data) {
  return request.post('/client-term/re-password', data)
}

export function modifyOfClientTerm(data) {
  return request.post('/client-term/modify', data)
}

export function uploadAncDocOfClientTerm(data) {
  return request.post('/client-term/upload-anc-doc', data)
}

export function getAncDocListOfClientTerm(data) {
  return request.post('/client-term/anc-doc-list', data)
}

export function deleteAncDocOfClientTerm(data) {
  return request.post('/client-term/delete-anc-doc', data)
}



// WEBPACK FOOTER //
// ./src/api/settings/client.js